<template>
  <div>
    <div>
      <a-button class="association-gsc" @click="associationAccount()">
        <img
          style="width: 18px; height: auto;"
          src="~@/assets/icon-google.png"
          alt=""
        />
        关联Google Search Console+
      </a-button>
    </div>
    <a-spin :spinning="loading">
      <div class="list">
        <div class="item" v-for="(item, index) in tableData" :key="index">
          <div class="name-box">
            <p class="name">{{item.name}}</p>
            <span @click="deleteFn(item.id)">删除</span>
          </div>
          <div class="email">
            {{item.email}}
          </div>
        </div>
        <div class="item no-item"></div>
        <div class="item no-item"></div>
        <div class="item no-item"></div>
      </div>
    </a-spin>
    <a-pagination
      :size="pagination.size"
      :page-size="pagination.pageSize"
      v-model:current="pagination.current"
      :total="pagination.total"
      :show-total="pagination.showTotal"
      show-quick-jumper
      @change="getList" 
    />
    <a-modal
      :visible="delMoadlVisible"
      wrap-class-name="delete-modal"
      :title="config.title"
      :width="config.width"
      :ok-text="config.confirmText"
      :cancel-text="config.cancelText"
      :mask-closable="false"
      @ok="confirmDel"
      @cancel="delMoadlVisible = false"
    >
      <div class="cont">
        <svg viewBox="64 64 896 896" focusable="false" data-icon="exclamation-circle" width="22px" height="22px" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path></svg>
        <span>删除后不可恢复，继续吗？</span>
      </div>
    </a-modal>
  </div>
</template>
<script>
import API from "./api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      pagination: {
        page: 1,
        pageSize: 20, // 默认每页显示数量 
        total: 0, //总条数
        current: 1,
        size: "small",
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
      },
      tableData: [],
      loading: false,
      config: {
        title: '确认删除',
        width: '460px',
        confirmText: '确定',
        cancelText: '取消'
      },
      delMoadlVisible: false,
      delId: ''
    };
  },
  created() {
    this.$store.state.adminleftnavnum =
      "/Sitmap"; //设置左侧导航2-2 active
  },
  mounted() {
    if(this.$route.query.type == 1) {
      this.$message.success(this.$route.query.msg);
    }
    if(this.$route.query.type == 2) {
      this.$message.error(this.$route.query.msg);
    }
    this.getList();
  },
  computed: {},
  components: {},
  methods: {
    getList(page) {
      let THAT = this;
      THAT.loading = true;
      THAT.pagination.page = page || 1;
      API.sitmap.GET_LIST({
        page: THAT.pagination.page
      }).then((res) => { 
        THAT.loading = false;
        if(res.data.code == 200) {
          THAT.tableData = res.data.data.data;
          THAT.pagination.total = res.data.data.total;
          THAT.pagination.current = res.data.data.current;
          THAT.pagination.current = res.data.data.current;
        }
      });
    },
    // 关联google账号
    associationAccount() {
      location.href = `${this.$store.state.urlExper}/customer/AGoogleSearchConsole/addGoogleAccount`
    },
    // 删除
    deleteFn(id) {
      let THAT = this;
      THAT.delMoadlVisible = true 
      THAT.delId = id
    },
    confirmDel() {
      let THAT = this;
      API.sitmap.DELE(THAT.delId).then((res) => {  
        if(res.data.code == 200) {
          THAT.delMoadlVisible = false
          THAT.$message.success(res.data.msg);
          THAT.getList(THAT.pagination.page)
        }
      });
    }
  },
};
</script>
<style scoped>
.association-gsc {
  display: flex;
  align-items: center;
}
.association-gsc img {
  margin-right: 5px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
}
.list .item {
  width: calc(25% - 15px);
  border: 1px solid #e8e8e8;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.3;
  word-break: break-word;
}
.list .item .name-box {
  padding: 8px;
  display: flex;
}
.list .item .name-box p {
  flex: 1;
  margin: 0;
}
.list .item .name-box span {
  color: #1890ff;
  cursor: pointer;
  margin-left: 5px;
}
.list .item .email {
  padding: 8px;
  border-top: 1px solid #e8e8e8;
}
.list .item.no-item {
  border: none;
}
.ant-pagination {
  float: right;
}
</style>
<style>
.delete-modal .ant-modal-header,.delete-modal .ant-modal-close-x {
  display: none;
}
.delete-modal .ant-modal-footer {
  border-top: none;
  padding: 10px 16px 30px;
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.delete-modal .ant-modal-footer>div {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.delete-modal .ant-btn+.ant-btn {
  margin-right: 20px;
}
.delete-modal .ant-modal-body svg { color: #faad14; margin-right: 10px; position: relative; top: 5px; }
</style>
